import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {getVendorPromotions} from "../../helpers/get_vendor_promotions";
import {IVendorDetailPromotion, VendorDetailPromotionBox} from "./boxes/VendorDetailPromotionBox";

interface IProps {
    promotions: IVendorDetailPromotion[];
    vendorSlug: string;
}

export const VendorDetailPromotions = (props: IProps) => {
    const {promotions} = props;
    const renderPromotions = getVendorPromotions({promotions});

    return (
        <>
            <Text as="h2" variant="headline_3" className={headingStyle}>
                Promocje i oferty specjalne
            </Text>

            <ul className={listStyle}>
                {renderPromotions.map((promotion) => (
                    <li key={promotion.id} className={listItemStyle}>
                        <VendorDetailPromotionBox promotion={promotion} vendorSlug={props.vendorSlug} />
                    </li>
                ))}
            </ul>
        </>
    );
};

const headingStyle = css({
    marginBottom: 4,
    md: {
        marginBottom: 6
    }
});

const listStyle = css({
    listStyle: "none",
    padding: 0,
    margin: 0
});

const listItemStyle = css({
    maxWidth: "375px",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 1.5,
    marginBottom: 1.5,
    md: {
        maxWidth: "unset",
        marginTop: 3,
        marginBottom: 3
    }
});
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {getVendorPromotions} from "../../helpers/get_vendor_promotions";
import {IVendorDetailPromotion, VendorDetailPromotionBox} from "./boxes/VendorDetailPromotionBox";

interface IProps {
    promotions: IVendorDetailPromotion[];
    vendorSlug: string;
}

export const VendorDetailPromotions = (props: IProps) => {
    const {promotions} = props;
    const renderPromotions = getVendorPromotions({promotions});

    return (
        <>
            <Text as="h2" variant="headline_3" className={headingStyle}>
                Promocje i oferty specjalne
            </Text>

            <ul className={listStyle}>
                {renderPromotions.map((promotion) => (
                    <li key={promotion.id} className={listItemStyle}>
                        <VendorDetailPromotionBox promotion={promotion} vendorSlug={props.vendorSlug} />
                    </li>
                ))}
            </ul>
        </>
    );
};

const headingStyle = css({
    marginBottom: 4,
    md: {
        marginBottom: 6
    }
});

const listStyle = css({
    listStyle: "none",
    padding: 0,
    margin: 0
});

const listItemStyle = css({
    maxWidth: "375px",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 1.5,
    marginBottom: 1.5,
    md: {
        maxWidth: "unset",
        marginTop: 3,
        marginBottom: 3
    }
});
